const ua = navigator.userAgent;
const isIOS = /iPhone|iPad|iPod/.test(ua);

function getIOSVersion() {
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);

  if (isSafari) {
    const safariVersion = ua.match(/Version\/(\d+)\.(\d+)/);

    if (safariVersion) {
      return parseFloat(`${safariVersion[1]}.${safariVersion[2]}`);
    }
  }

  const osVersion = ua.match(/OS (\d+)_(\d+)/);

  return osVersion ? parseFloat(`${osVersion[1]}.${osVersion[2]}`) : 0;
}

export const isIOS26OrHigher = isIOS && getIOSVersion() >= 26;
export const isFirefox = /firefox/i.test(ua);
